<template>
	<div class="step3">
		<div class="header">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="header_tit"><span>|</span> 会员管理系统</h5>
			<p class="welcom">欢迎您 <span class="name">{{name}}</span><span>|</span></p>
			<a class="out"  @click="out">退出</a>
		</div>
		<div class="middle">
			<p class="introducer">入会流程</p>
			<div class="con">
				<div class="con_top">
					<p class="flow_pic">
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">注册账号</span> <span class="line line1"></span>
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">填写入会申请表</span> <span class="line line1"></span>
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">打印盖章并上传</span> <span class="line line1"></span>
						<span class="cirl">4</span> <span class="flow2 flow">缴费并等待审核</span> 
					</p>
				</div>
				<div class="tit">
						<img class="wait fl clearfix" src="../../static/img/wait.png" />
						<div class="fl clearfix" style="height: 102px;padding-top: 22px;margin-left: 20px;">
							<p style="font-size: 16px;color: #404040;font-weight: bold;line-height: 40px;">您的资料正在审核中</p>
							<span style="line-height: 40px;">所有资料审批通过即可成为正式会员，获得会员编号，享受完整会员服务。</span>
						</div>
				</div>
				<div class="con_center">
					<div class="center_con">
						<img class="hetong" src="../../static/img/hetong.png"  />
						<div class="center_center">
							<p class="center_tit">入会申请审核</p>
							<p class="shenhe" v-show="shenhe">资料审核中,请您耐心等待,审核工作约15个工作日内完成</p>
							<p class="btns" v-show="bohui">
								<span class="bohui">驳回</span>
								<span class="watch" @click='check' style="cursor:pointer;" >查看驳回理由</span>
								<router-link class="back"  to="/step1">返回修改</router-link>
							</p>
							<p class="pass" v-show="pass">审核通过</p>
						</div>
						<div class="center_right">
							<router-link  class="down_load" style="cursor: pointer;color: #4A90E2;" to="/step22">下载《入会申请表》</router-link>
							<!--<a @click="get_adress" style="cursor: pointer;">查看邮寄地址</a>-->
						</div>
					</div>
				</div>	
				<div class="con_bot">
					<div class="bot_top">
						<img class="copy_img" src="../../static/img/copy5.png"  />
						<div class="bot_top_right">
							<p>缴纳会费</p>
							<span>普通单位会员¥5000/年 &nbsp;&nbsp;&nbsp;理事及以上单位会员¥10000/年 &nbsp;&nbsp;&nbsp;个人会员¥480/年</span>
						</div>
					</div>
					<div class="bot_bot">
						<p style="margin-bottom: 20px;">会费转账信息</p>						
						<div class="msg">
							<span></span>
							<p>
								会费请汇至： 中国质量协会<br>	
							 	银行帐号：0200002809014498969 <br>	
							 	开 户 行：工商银行北京西四支行 <br>	
							 	请注明项目：会费 <br>	
							</p>
						</div>						
						<p style="font-size: 14px;">
							缴费成功且管理员核实会费到账后，可登录系统进行开会费票据申请；如企业财务需要提前开具会费票据，<i style="color: red;">请耐心等待入会审核通过后</i>，点击 
							<a target="_blank" @click="toInvoice" style="color: #077aff;cursor: pointer;">预支会费票据申请</a>
							<!--<router-link  target="_blank" to="/invoice" style="color: #077aff;">预支会费票据申请</router-link>。-->
						</p>
					</div>
					<div class="bot_center">
						<span class="jfpz">查询缴费进度</span>
						<button class="query" @click="query">申请查看缴费状态</button>					   					
						<span style="font-size: 16px;font-weight: bold;color: #404040;">缴费状态：</span>
						<span style="color: #FF9600;">{{status}}</span>	
						<p style="color: #ff4e4e;font-size: 12px;text-indent: 95px;">（请确认缴费后点击此按钮）</p>
					</div>
										
					
				</div>
			</div>			
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	import bottom from './Bottom'
	import Qs from 'qs'
  	export default {
  		components: {
			bottom
		},
	    data() {	    	
		    return {
		    	status:'',
		    	shenhe:false,
		    	bohui:false,
		    	pass:false,
		    	name:'',
		    };
	    },
	    
		created() {
	  	},
	  	mounted() {
	  		if(sessionStorage.getItem('name')){
			    this.name =  sessionStorage.getItem('name');
			};
		   if(sessionStorage.getItem('Token')){
			    var token =  sessionStorage.getItem('Token');
			};
			var data1={
				'access-token':token
			};
		   this.$axios({
				method: 'post',
				url: 'society/applicationform',
				data: Qs.stringify(data1)
			}).then(response => {
				if(response.data.state==2){
					switch(Number(response.data.data.apply_status)){
						case 0:
						this.shenhe=true;
						break;
						case 1:
						this.pass=true;
						break;
						default:
						this.bohui=true;
					}
				}			
			});	
			this.$axios({
				method: 'post',
				url: 'payment/paymentpage_2',
				data: Qs.stringify(data1)
			}).then(response => {
				this.status = response.data.msg;					
			});	  
			
		  },
	    methods: {
	    	toInvoice(){
				let {href} = this.$router.resolve({path:'/invoice'});
				window.open(href, '_blank');
			},
	    	out(){
	    		if(sessionStorage.getItem('Token')){
			        var token =  sessionStorage.getItem('Token');
			    };
			    var data1={
					'access-token':token
				};
			    this.$axios({
					method: 'post',
					url: 'user/logout',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state==1){
//						sessionStorage.removeItem('Token');
//						localStorage.removeItem('sessionid');
						localStorage.clear();
						sessionStorage.clear();
						this.$router.push('/login');
					}else{
						this.$toast(response.data.msg);
					}
				})
	    	},	    	
			check(){
				if(sessionStorage.getItem('Token')){
				    var token =  sessionStorage.getItem('Token');
				};
				var data1={
					'access-token':token
				};
				this.$axios({
					method: 'post',
					url: 'society/companyapply',
					data: Qs.stringify(data1)
				}).then(response => {	
					if(response.data.state==3){
						this.$alert(response.data.reason.reason, '驳回理由', {
				          	callback: action => {
			            
			        		}
				      	});	
					}else{
						this.$toast(response.data.msg);
					}
					
				
				});	  
			},
			query(){
				if(sessionStorage.getItem('Token')){
				    var token =  sessionStorage.getItem('Token');
				};
				var data1={
					'access-token':token
				};
				this.$confirm('请您和公司财务确认，已经按提示完成了转账缴费事宜。', '注意', {
			        distinguishCancelAndClose: true,
			        confirmButtonText: '确认已缴费',
			        cancelButtonText: '还未交费'
			    })
			    .then(() => {
			       	this.$axios({
						method: 'post',
						url: 'payment/checkpaymentprogress',
						data: Qs.stringify(data1)
					}).then(response => {
						this.$toast(response.data.msg)				
					});	  
			    })
			    .catch(action => {
			    });
			},
			get_adress(){
				this.$alert('<p>联系部门：中国质量协会会员服务部<br>地址：北京海淀区三虎桥百胜村6号 <br>邮 编：100048  &nbsp;&nbsp;&nbsp;电话：（010）66072472,66013615 <br>传真：（010）66013615 &nbsp;&nbsp; 邮箱： songyl@caq.org.cn <br>收件人：宋月琳，赵玉翠</p> ', '邮寄地址', {
		          	dangerouslyUseHTMLString: true,
		          	callback: action => {
			            
			        }
		      	});				
			}
	    }
	}

</script>
<style scoped >
.clearfix::after {
	content: ".";
	clear: both;
	visibility: hidden;
	height: 0;
	display: block;
	line-height: 0;
}
	
.clearfix {
	zoom: 1;
}
.fl{
	float: left;
}
.step3 {
	width: 100%;
	height: auto;
	background: #fff;
	font-family: PingFangSC-Medium;
	font-size: 14px;
}

.header {
	height: 80px;
	position: relative;
}

.logo {
	width: 211px;
	height: 43px;
	position: absolute;
	top: 16px;
	left: 254px;
}

.header_tit {
	position: absolute;
	top: 26px;
	left: 480px;
	height: 28px;
	font-size: 20px;
	font-weight: bold;
	color: rgba(0, 94, 179, 1);
	line-height: 28px;
}

.header_tit span {
	height: 17px;
	color: #E8E8E8;
}

.welcom {
	position: absolute;
	top: 30px;
	right: 271px;
	width: 340px;
	text-align: right;
	color: #808080;
}

.name {
	color: #4A90E2;
	margin-right: 14px;
}

.out {
	cursor: pointer;
	position: absolute;
	top: 30px;
	right: 226px;
	font-size: 14px;
	font-weight: bold;
	color: #808080;
	line-height: 20px;
}

.middle {
	border-top: 1px solid rgba(0, 0, 0, 0);
	box-sizing: border-box;
	width: 100%;
	padding-bottom: 35px;
	background: rgba(246, 248, 249, 1);
}

.introducer {
	font-size: 24px;
	color: #404040;
	text-align: left;
	text-indent: 254px;
	line-height: 75px;
}

.con {
	text-align: left;
	margin: 0 auto;
	width: 960px;
	padding-bottom: 45px;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
}

.con_top {
	padding-top: 25px;
	height: 45px;
	border-bottom: 1px solid #E0E0E0;
}

.flow_pic {
	height: 20px;
	text-align: center;
	vertical-align: middle;
	color: #595959;
}

.yet {
	margin-right: 14px;
	width: 20px;
	height: 20px;
	display: inline-block;
	vertical-align: middle;
}

.flow1 {
	color: #0076FF;
}

.flow2 {
	color: #FF9600;
}

.line {
	margin: 0 19px;
	width: 47px;
	height: 2px;
	display: inline-block;
	background: #BFBFBF;
	vertical-align: middle;
}

.line1 {
	background: #0076FF;
}

.cirl {
	display: inline-block;
	width: 20px;
	height: 20px;
	border: 1px solid #BFBFBF;
	border-radius: 100%;
	line-height: 20px;
	text-align: center;
	color: #BFBFBF;
	margin-right: 14px;
}
.con_center {
	width: 720px;
	margin-bottom: 35px;
	border-bottom: 1px solid #979797;
	margin: 55px 0 35px 111px;
}
.tit{
	width: 100%;
	overflow: hidden;
	padding: 116px 0 131px 118px;
	box-sizing: border-box;
	border-bottom: 2px solid #E0E0E0;
}
.wait{
	width: 175px;
	height: 124px;
}
.center_con {
	height: 160px;
	width: 100%;
}
.hetong {
	width: 80px;
	height: 80px;
	float: left;
}
.center_center {
	/*width: 243px;*/
	height: 150px;
	float: left;
	margin-left: 34px;
}

.center_tit {
	color: #404040;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 16px;
}

.shenhe {
	height: 21px;
	line-height: 21px;
	padding-left: 30px;
	background: url(../../static/img/see.png) no-repeat left 4px;
	background-size:23px 15px ;
	font-family: PingFangSC-Regular;
	color: #F5A623;
	margin-bottom: 16px;
}
.btns {
	margin-bottom: 16px;
	font-family: PingFangSC-Regular;
}

.bohui {
	height: 20px;
	line-height: 20px;
	padding-left: 35px;
	background: url(../../static/img/bohui.png) no-repeat left top;
	background-size:22px 20px;
	color: #FF2C46;
}

.watch {
	color: #0076FF;
	margin: 0 35px 0 20px;
}
.back {
	color: #0076FF;
}
.pass {
	height: 20px;
	line-height: 20px;
	padding-left: 35px;
	background: url(../../static/img/pass.png) no-repeat left top;
	background-size:22px 20px;
	color: #16A085;
}

.center_right {
	height: 100px;
	float: right;
	color: #4A90E2;
	font-family: PingFangSC-Regular;
}

.center_right a {
	display: inline-block;
}

.down_load {
	margin-right: 15px;
}

.con_bot {
	width: 720px;
	height: auto;
	margin-left: 111px;
}

.bot_top {
	width: 100%;
	height: 80px;
	margin-bottom: 20px;
}

.copy_img {
	width: 80px;
	height: 80px;
	float: left;
}

.bot_top_right {
	float: left;
	margin-left: 34px;
	color: #404040;
}

.bot_top_right p {
	padding-top: 15px;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 16px;
}

.bot_center {
	width: 583px;
	height: auto;
	margin: 0 0 30px 120px;
	line-height: 32px;
}
.jfpz {
	display: inline-block;
	font-size: 16px;
	font-weight: bold;
	color: #404040;
}
.query{
	display: inline-block;
	top: 45px;
	right: 45px;
	color: #fff;
	width: 124px;
	height: 40px;
	background: #0076ff;
	border-radius: 3px;
	border: none;
	box-sizing: border-box;
	margin: 0 20px 0 10px;
}

.bot_bot {
	width: 583px;
	height: auto;
	margin-left: 120px;
	margin-bottom: 35px;
}

.bot_bot p {
	color: #404040;
	font-size: 16px;
	font-weight: bold;
}
.msg {
	position: relative;
	width: 560px;
	height: 110px;
	background: rgba(255, 245, 204, 1);
	padding: 20px 0 0 23px;
	border-radius: 5px;
	margin-bottom: 35px;
}
.msg p {
	font-size: 14px;
	font-family: PingFangSC-Regular;
	font-weight: 400;
	color: rgba(64, 64, 64, 1);
	line-height: 24px;
}
.msg span {
	position: absolute;
	top: -10px;
	width: 0;
	height: 0;
	border-right: 10px solid transparent;
	border-left: 10px solid transparent;
	border-bottom: 10px solid rgba(255, 245, 204, 1);
}
.to_invoice {
	position: absolute;
	text-align: center;
	line-height: 40px;
	top: 45px;
	right: 45px;
	color: #fff;
	width: 124px;
	height: 40px;
	background: rgba(255, 150, 0, 1);
	border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Step3.vue